/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Group_ProductInputs */

const en_reference_group_product = /** @type {(inputs: Reference_Group_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product`)
};

/**
* | output |
* | --- |
* | "Product" |
*
* @param {Reference_Group_ProductInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_group_product = /** @type {((inputs?: Reference_Group_ProductInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Group_ProductInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_group_product(inputs)
});